import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from 'src/app/providers/common.service';
import { UserService } from 'src/app/providers/user.service';
import { LoginAsModalComponent } from 'src/app/shared/components/login-as-modal/login-as-modal.component';
import { forkJoin } from 'rxjs';
import { Users } from 'src/app/core/model/user';
import { AuthService } from 'src/app/providers/auth.service';
import * as moment from 'moment';
import { FormControl, FormGroup } from '@angular/forms';
import { DownloaderLoaderComponent } from 'src/app/shared/components/downloader-loader/downloader-loader.component';
import { saveAs } from 'file-saver';
import { Modules } from 'src/app/core/model/modules.enum';
import { Privileges } from 'src/app/core/model/privileges.enum';
@Component({
  selector: 'app-merchant-billing',
  templateUrl: './merchant-billing.component.html',
  styleUrls: ['./merchant-billing.component.scss']
})
export class MerchantBillingComponent implements OnInit {
  public customerInfo: any = localStorage.getItem('current_user') ? JSON.parse(localStorage.getItem('current_user')) : {};
  public midLabelArray: any[] = [];
  public billingStatus: any = {};
  public billingSummary: any = {};
  public isLoading: boolean = true;
  public isSummaryLoading: boolean = true;
  public isFilter: boolean = false;
  public invoiceIdloading: boolean = false;
  public DownloadModalReference: any;
  public invoiceRecords: any[] = [];
  public invoiceIdsList: any[] = [];
  notFoundText: string = 'Type at least 3 letters';

  monthList = moment.months().map((data, index) => {
    return { label: data, value: index + 1 };
  });
  public selectedMonth: any;
  startYear = 2022;
  yearList: any[] = [];
  public isDisableProxyLogin: boolean = false;
  public disableFilter: boolean = false;
  searchTimeout: any;
  public filterForm: FormGroup = new FormGroup({
    invoiceId: new FormControl(),
    month: new FormControl(),
    year: new FormControl(),
  })
  public isFormValid: boolean = false;
  public errors :any ={};
  public editBilling: boolean = this.isAccess(Modules.MERCHANT_BILLING, Privileges.EDIT_BILLING)
  constructor(private router: Router, private common: CommonService, private messageService: MessageService,
    private ngbModal: NgbModal, private userService: UserService, private authService: AuthService,


  ) { }

  ngOnInit(): void {
    let selectedYear = Number(moment().format("YYYY"));
    for (let i = this.startYear; i <= selectedYear; i++) {
      this.yearList.push({ label: i, value: i });
    }
    this.getBillingStatus();
    this.getInvoices();
    this.getProxyLoginDetails();
    this.filterForm.valueChanges.subscribe(values => {
      this.isFormValid = Object.values(values).some(value => value !== null && value !== '');
      if (!this.isFormValid && this.filterForm.enabled) {
        this.getInvoices()
      }
    });
  }

  onSearchInvoiceId(term: string) {
    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      if (term?.length >= 3) {
        this.invoiceIdloading = true;
        this.notFoundText = 'No results found';
        this.getInvoicesIdList(term);
      } else {
        this.notFoundText = 'Type at least 3 letters';
        this.invoiceIdsList = [];
        this.invoiceIdloading = false;
      }
    }, 300);
  }

  addAccount = () => {
    this.router.navigate(["/merchant-management/merchant-create-management"], { queryParams: { action: 'm-b', redirectTo: 'm-b' } })
  }

  navigateFn = (path: string, params?: any) => {
    params = { ...params, ...this.billingStatus, ...this.billingSummary }
    if (!params.totalMerchants && params.from == 'bulk_update') {
      this.showToaster('error', '', 'No merchants found to update.');
      return;
    }
    this.router.navigate([`/billing-invoice/${path}`], { queryParams: params || {} });
  }
  navigateToInvoice = (data: any) => {
    this.router.navigate([`/billing-invoice/invoice-details`], {
      queryParams: {
        month: data.month, year: data.year, invoiceNumber: data.invoiceNumber, billingStatus: JSON.stringify(this.billingStatus ? this.billingStatus : {}),
        billingSummary: JSON.stringify(this.billingSummary ? this.billingSummary : {})
      }
    });
  }

  getBillingStatus = () => {
    this.common.postCommonHttpClient(apiLinks.merchantBilling.billingStatus, { customerId: this.customerInfo.customerId }).pipe(take(1)).subscribe((res: any) => {
      this.billingStatus = res.data || {};
      this.billingStatus.failed = false;
      // this.statusLoader = false;
          this.getBillingSummary();

    }, error => {
      this.showToaster('error', '', 'failed !');
      this.billingStatus = { failed: true };
      this.isLoading = false;
    })
  }

  getBillingSummary = () => {
    this.isSummaryLoading = true;
    this.common.getCommonHttpClientParams(`${apiLinks.merchantBilling.getBillingSummary}`).pipe(take(1)).subscribe((res: any) => {
      this.billingSummary = res.data;
      if (this.billingStatus.isCAOnboard && !this.billingStatus.setSellingPrice) {
        this.router.navigate(
          ['/billing-invoice/m-b-s'],
          {
            queryParams: {
              billingStatus: JSON.stringify(this.billingStatus || {}),
              billingSummary: JSON.stringify(this.billingSummary || {})
            }
          }
        );
        return;
      }
      this.isLoading = this.isSummaryLoading = false;
    }, error => {
      this.showToaster('error', '', 'failed !');
      this.isLoading = this.isSummaryLoading = false;
    })
  }

  showToaster(type, define, message, id?: string) {
    this.messageService.add({
      severity: type,
      summary: define,
      detail: message,
      key: 'copy-toast'
    });
  }

  loginAs() {
    if (!this.billingSummary.accountInfo?.userId) {
      return;
    }
    let modalRef = this.ngbModal.open(LoginAsModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.isLoading = true
    modalRef.componentInstance.header = `LOGIN-AS CONFIRMATION`;
    let payLoad = {
      ownedByCustomer: this.customerInfo.customerId
    };
    let getUserApi = this.userService.getUser(this.userService.getUserById, { id: this.billingSummary.accountInfo?.userId });
    let getProxyEmailStatusApi = this.common.getCommonHttpClientQueryParams(apiLinks.isEnableProxyEmailAlert, payLoad);
    forkJoin([getUserApi, getProxyEmailStatusApi]).pipe(take(1)).subscribe(([userApiRes, proxyEmailRes]) => {
      const userResponse = userApiRes as Users
      modalRef.componentInstance.body = `Do you want to login as your Collection Account ?`;
      modalRef.componentInstance.confirmButton = `Confirm`
      modalRef.componentInstance.email = userResponse.email;
      // modalRef.componentInstance.password = userResponse.secondaryPassword;
      modalRef.componentInstance.systemUser = this.authService.getUser.firstName + " " + this.authService.getUser.lastName;
      modalRef.componentInstance.systemEmail = this.authService.getUser.email;
      modalRef.componentInstance.isLoading = false;
      modalRef.componentInstance.loginUser = 'Merchant';
      modalRef.componentInstance.isEnableProxyEmail = proxyEmailRes.isEnableProxyMail;
    }, (err) => {
      modalRef.componentInstance.isLoading = false
      modalRef.componentInstance.body = `Error occurred, ${err.message}`;
      modalRef.componentInstance.isError = true

    });

  }

  clear() {
    this.filterForm.reset();
    this.isFilter = false;
    this.getInvoices();

  }

  getInvoices = () => {
    this.isLoading = true;
    this.common.postCommonHttpClient(`${apiLinks.merchantBilling.getInvoicesMonthly}`, this.filterForm.value).pipe(take(1)).subscribe((res: any) => {
      this.invoiceRecords = res.data.items || [];
      if (!((this.billingSummary?.totalMerchants || 0) - (this.billingSummary?.pendingMerchants || 0)) && !this.invoiceRecords.length) {
        this.filterForm.disable();
        this.disableFilter = true;
      }
      this.isLoading = false;
    }, error => {
      // this.showToaster('error', '', error.message);
      this.isLoading = false;
      this.errors.invoiceRecords = error.status;
      this.invoiceRecords = [];
    })
  }
  getInvoicesIdList = (term: string) => {
    this.common.getCommonHttpClientParams(`${apiLinks.merchantBilling.getInvoiceIds}?term=${term}`).pipe(take(1)).subscribe((res: any) => {
      this.invoiceIdsList = res.data.items || [];
      this.invoiceIdloading = false;

    }, error => {
      this.invoiceIdloading = false;
      this.invoiceIdsList = [];
    })
  }

  onSelectId = (data: any) => {
    if (data?.invoiceNumber) {
      this.navigateToInvoice(data)
    }
  }

  getProxyLoginDetails() {
    this.common.getCommonHttpClientParams(apiLinks.getProxyAlertDetails + '/' + this.customerInfo.customerId).subscribe((res) => {
      if (res.data?.length) {
        this.isDisableProxyLogin = res.data.find((d: any) => { return d.isoPreferences_to_isoPreferenceMapping?.code == "isMerchantLoginAs" })?.status == 'ACTIVE' ? false : true;
      } else {
        this.isDisableProxyLogin = true;
      }
    }, (err) => {
      this.isDisableProxyLogin = true;

    })
  }

  searchFn = () => {
    this.isFilter = true;
    this.getInvoices();
  }

  showDownloadDialog(bodyContent = "Downloading") {
    window.scroll(0, 0);
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
    };
    this.DownloadModalReference = this.ngbModal.open(DownloaderLoaderComponent, ngbModalOptions);
    this.DownloadModalReference.componentInstance.isLoading = true;
    this.DownloadModalReference.componentInstance.body = bodyContent;
  }


  download() {
    this.showDownloadDialog();
    this.common
      .postCommonFileDownload(
        apiLinks.merchantBilling.invoiceDownload,
        this.filterForm.value
      )
      .subscribe({
        next: (blob: Blob) => {
          const date = new Date().toISOString().slice(0, 10);
          const fileName = `Invoices-${date}.xlsx`;
          const url = window.URL.createObjectURL(blob);
          saveAs(url, fileName);
          window.URL.revokeObjectURL(url);
          this.DownloadModalReference?.close();
        },
        error: (err: any) => {
          if (err.error instanceof Blob && err.error.type.includes('application/json')) {
            err.error.text().then((text: string) => {
              let msg = 'Unknown server error';
              try {
                msg = JSON.parse(text)?.message || msg;
              } catch {
                msg = text;
              }
              this.showToaster('error', '', msg);
              this.DownloadModalReference?.close();
            });
          } else {
            this.showToaster('error', '', err.message || 'Download failed');
            this.DownloadModalReference?.close();
          }
        }
      });
  }
  isAccess(module, privileges) {
    return this.authService.isFeatureEnabled(module, privileges);
  }
}
